import { Grid2, Stack, Typography } from "@mui/material";
import ModeButton from "./ModeButton";
import ScheduleButton from "./ScheduleButton";
import { SaveChangesButton } from "./SaveChangesButton";
import { RevertAllChangesButton } from "./RevertAllChangesButton";
import { useTheme } from "@mui/material";

export default function SubHeaderBar({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode
    let channelData = params.channelData
    let handleSaveAllChangesClick = params.handleSaveAllChangesClick
    let handleRevertAllChangesClick = params.handleRevertAllChangesClick
    let theme = useTheme()

    return (
        <Grid2 display={'flex'} justifyContent={'center'} width={'100%'} backgroundColor={theme.palette.NewChannelPage.subheader}>
            <Stack direction={'row'} spacing={'20px'}>
                <Typography>my_logo</Typography>
                <Typography>{channelData.call_sign + "-" + channelData.affiliation}</Typography>
                <Typography>{channelData.market}</Typography>
                <ModeButton pageMode={pageMode} setPageMode={setPageMode}></ModeButton>
                {(pageMode === 'read') && (
                    <ScheduleButton pageMode={pageMode} setPageMode={setPageMode}></ScheduleButton>
                )}
                {(pageMode === 'edit') && (
                    <>
                        <SaveChangesButton handleSaveAllChangesClick={handleSaveAllChangesClick}/>
                        <RevertAllChangesButton handleRevertAllChangesClick={handleRevertAllChangesClick}/>
                    </>
                )}

            </Stack>
        </Grid2>
    )
}